import { mapGetters, mapActions } from 'vuex'
import user from '@/api/user'
import { minvitedReviewer } from '@/api/reviewer'
import { inviteMacademic } from '@/api/macademic'
import manuscript from '@/api/manuscript'
import help from '@/utils/help'
export default {
  data() {
    return {
      form: {
        email: '',
        password: ''
      },
      rules: {}
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      language: 'getLanguage',
      publisherInfo: 'getPublisherInfo',
      publisherId: 'getPublisherId'
    })
  },
  async mounted() {
    this.key = this.$route.query.key
    this.reviewskey = this.$route.query.reviewskey
    this.reviewstype = this.$route.query.reviewstype
    this.decisionKey = this.$route.query.decisionKey
    this.decisionType = this.$route.query.decisionType
    this.reviseKey = this.$route.query.reviseKey
    if (this.key) {
      await this.activation()
    } else if (this.reviewskey) {
      await this.minvitedReviewerToken()
    } else if (this.decisionKey) {
      await this.minvitedAcademicToken()
    } else if (this.reviseKey) {
      await this.reviseToken()
    } else {
      this.getRules()
      await this.getInfo()
    }
    document.onkeyup = e => {
      // 兼容FF和IE和Opera
      var event = e || window.event
      var key = event.which || event.keyCode || event.charCode
      if (key == 13 && this.$route.path === '/access/login') {
        this.submit()
      }
    }
  },
  methods: {
    ...mapActions(['updateUser', 'updateLanguage', 'updateToken']),
    async submit() {
      const flag = this.$refs['login-form'].validate()
      if (flag) {
        const data = Object.assign({ publisherId: this.publisherId }, this.form)
        await user.login(data)
        this.getInfo()
      }
    },
    async activation() {
      const { token, refreshToken, expire } = await user.activation(this.key)

      localStorage.setItem('token', 'Bearer ' + token)
      this.updateToken('Bearer ' + token)
      localStorage.setItem('refreshToken', refreshToken)
      localStorage.setItem('expire', expire)

      this.$message.success({
        title: 'Success',
        content: 'Account activated successfully'
      })
      this.getInfo()
    },
    async reviseToken() {
      const data = await manuscript.authorLogin(this.reviseKey)

      if (!data) {
        return
      }
      const { token, refreshToken, expire, id, sign } = data

      localStorage.setItem('token', 'Bearer ' + token)
      this.updateToken('Bearer ' + token)
      localStorage.setItem('refreshToken', refreshToken)
      localStorage.setItem('expire', expire)
      const res = await user.info()
      res.roles = res.roleList.map(item => {
        return item.type
      })
      this.updateUser(res)
      this.$router.push(
        `/author/submitted-manuscripts/author-revised?id=${id}&sign=${sign}`
      )
    },
    async minvitedReviewerToken() {
      const data = await minvitedReviewer.token({
        key: this.reviewskey,
        reviewsType: this.reviewstype
      })

      if (!data) {
        this.$router.push('/other-author/unable')
        return
      }
      const { token, refreshToken, expire, mreviewerId, version, status } = data

      localStorage.setItem('token', 'Bearer ' + token)
      this.updateToken('Bearer ' + token)
      localStorage.setItem('refreshToken', refreshToken)
      localStorage.setItem('expire', expire)
      const res = await user.info()
      res.roles = res.roleList.map(item => {
        return item.type
      })
      this.updateUser(res)

      if (mreviewerId) {
        let url =
          status === 'AGREED'
            ? 'agree'
            : this.reviewstype === 'agree'
            ? 'confirm'
            : this.reviewstype === 'refuse'
            ? 'refuse'
            : ''
        this.$router.push(
          `/reviewers-menu/reviews/reviews-${url}?id=${mreviewerId}&version=${version}`
        )
      } else {
        this.$router.push(`/reviewers-menu/reviews`)
      }
    },
    async minvitedAcademicToken() {
      const data = await inviteMacademic.login({
        decisionKey: this.decisionKey,
        decisionType: this.decisionType
      })

      if (!data) {
        this.$router.push('/other-author/unable')
        return
      }
      const {
        token,
        refreshToken,
        expire,
        macademicId,
        manuscriptId,
        sign,
        type
      } = data

      localStorage.setItem('token', 'Bearer ' + token)
      this.updateToken('Bearer ' + token)
      localStorage.setItem('refreshToken', refreshToken)
      localStorage.setItem('expire', expire)
      const res = await user.info()
      res.roles = res.roleList.map(item => {
        return item.type
      })
      this.updateUser(res)

      let decisionType = ''
      if (this.decisionType === 'pre_check') {
        decisionType = 'PRE_CHECK'
      } else if (this.decisionType === 'first_decision') {
        decisionType = 'FRIST_CHECK'
      } else if (this.decisionType === 'final_decision') {
        decisionType = 'FINAL_CHECK'
      }

      if (macademicId) {
        this.$router.push(
          `/academic-menu/academic/submit/${decisionType}/${macademicId}?manuscriptId=${manuscriptId}&sign=${sign}&type=${type}`
        )
      } else {
        this.$router.push(`/academic-menu/academic`)
      }
    },
    getRules() {
      this.rules = {
        email: [
          {
            required: true,
            message: 'Username' + this.LANGUAGE[this.language].noEmpty + '.'
          },
          {
            type: 'email',
            message: this.LANGUAGE[this.language].inputCorrectEmail + '.'
          }
        ],
        password: [
          {
            required: true,
            message: 'Password' + this.LANGUAGE[this.language].noEmpty + '.'
          },
          {
            min: 6,
            message: `Password should be more than 6 characters.`
          },
          {
            max: 20,
            message: `Password length must not be more than 20 characters.`
          },
          {
            pattern: /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{6,20}$/,
            message: `Must be composed of letters, numbers, and symbols, but not spaces.`
          }
        ]
      }
    },
    async getInfo() {
      if (!localStorage.getItem('token')) {
        return
      }
      const res = await user.info()
      res.roles = res.roleList.map(item => {
        return item.type
      })
      this.updateUser(res)
      this.updateToken(localStorage.getItem('token'))
      // const curr = localStorage.getItem('preRoute')
      // if (
      //   curr != '/' &&
      //   curr != '/access/login' &&
      //   !curr.includes('/email-url')
      // ) {
      //   this.$router.push(curr)
      // }
      if (
        help.arrIncludes(this.user.roles, [
          'OTHER',
          'PUBLISHER_ADMIN',
          'MANAGER_EDITOR',
          'WEBSITE_EDITOR'
        ])
      ) {
        this.$router.push('/home')
      } else if (
        help.arrIncludes(this.user.roles, ['EDITORIAL_BOARD', 'GUEST_EDITOR'])
      ) {
        this.$router.push('/academic-menu/academic')
      } else if (help.arrIncludes(this.user.roles, ['REVIEWER'])) {
        this.$router.push('/reviewers-menu/reviews')
      } else if (help.arrIncludes(this.user.roles, ['AUTHOR'])) {
        this.$router.push('/author/submitted-manuscripts')
      } else {
        this.$router.push('/user-manage/profile')
      }
    }
  }
}
